import { postApv, postBrandAprv } from '../../apis';
import { SDK_DOMAIN } from '../../constants';
import {
  deserialize,
  getIframe,
  getLocationPath,
  setAddEventListener,
} from '../../helpers';
import { replaceRouter, routes } from '../../router';

const OnlinePayComplete = {
  render: async () => {
    return '';
    // return `
    // <div>
    //   <a id="connect_pay_back_button" class="c_back"></a>
    // </div>
    // <div class="c_title1">결제 완료</div>

    // <div id="contents" style="display:none">
    //   <div class="c_result_icon m_b_20"><img src="${SDK_DOMAIN}/images/icon-success.png" /></div>
    //   <div class="c_label4_4 m_b_20 text_center">결제가 완료되었습니다.</div>

    //   <div class="bottom_btn_wrapper">
    //     <button id="ok_btn" class="btn c_btn1 skin1_btn m_t_25">확인</button>
    //   </div>
    // </div>
    // `;
  },
  afterRender: async () => {
    // const state = history.state;
    const data = deserialize(sessionStorage.getItem('CONPAY_COMPLETE_INFO'));
    if (data == null) {
      replaceRouter(
        { message: '올바르지 않은 접근입니다' },
        null,
        routes.resultPage.hashPath
      );
      return;
    }

    try {
      // 결제 예약 API
      // const res = await postApv(state.rsvdUrl, data);

      // // 브랜드사 백엔드에서 결제 승인 API 데이터
      // const aprvData = {
      //   trDiv: data.trDiv,
      //   rsvdno: res.rsvdno,
      //   orderNo: data.orderNo,
      //   trAmt: data.trAmt,
      // };

      const aprvData = {
        trDiv: data.trDiv,
        rsvdno: data.rsvdno,
        orderNo: data.orderNo,
        trAmt: data.trAmt,
      };
      window.brandResolve(aprvData);

      // await postBrandAprv(state.aprvUrl, aprvData);
      getIframe().getElementById('contents').style.display = 'block';
    } catch (e) {
      console.log(window.brandReject);
      window.brandReject(e);
      // replaceRouter(
      //   { title: '결제 실패', message: e.resultMessage },
      //   null,
      //   routes.resultPage.hashPath
      // );
    } finally {
      sessionStorage.removeItem('CONPAY_COMPLETE_INFO');
      const locationPath = getLocationPath();
      window.parent.location.replace(`${locationPath}#close`);
    }

    // setAddEventListener('ok_btn', () => history.go(-2));
    // setAddEventListener('connect_pay_back_button', () => history.go(-2));
  },
};
export default OnlinePayComplete;
